import { useContext } from 'react';
import cn from 'classnames';
import Button from './Button';
import { ThemeContext } from '../context/ThemeProvider';
import Sun from '../../assets/svg/sun.svg';
import Moon from '../../assets/svg/moon.svg';
import { THEME } from '../../config/theme';
import useAnalyticsEvent from '../../hooks/useAnalyticsEvent';

const ThemeToggle = () => {
  const { theme, setColorTheme } = useContext(ThemeContext);
  const emitEvent = useAnalyticsEvent();
  const { DARK, LIGHT } = THEME;
  const isDarkTheme = theme === DARK;

  const onClick = () => {
    const activeTheme = isDarkTheme ? LIGHT : DARK;
    setColorTheme(activeTheme);

    emitEvent({
      action: 'themeToggleClick',
      category: 'themeToggle',
      label: 'toggled',
      value: activeTheme,
    });
  };

  // If no theme yet, don't display. Prevents slight flicker between icons on initial mount
  if (!theme) return null;

  return (
    <Button
      className={cn('theme-toggle', theme)}
      onClick={onClick}
      title={`Use ${isDarkTheme ? 'light' : 'dark'} theme`}
      variation="reset"
    >
      {isDarkTheme ? <Sun /> : <Moon />}
    </Button>
  );
};

export default ThemeToggle;
